// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"cc01dc6c","977":"6f89b74b"}[chunkId] + ".chunk.js";
};